export const homeText = {
  description: "",
  ctaButtons: [
    {
      text: "Equivalence<br>gamme Sika",
      screen: "sika-products",
    },
    {
      text: "Equivalence<br>gamme concurrents",
      screen: "other-products",
    },
    {
      text: "Adjuvantation<br>sur-mesure",
      screen: "simulator",
    },
  ],
};
